<template functional>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="$options.methods.getViewbox(props)"
    class="icon"
    :class="$options.methods.getStyleClasses(props)"
    v-bind="data.attrs"
    v-on="listeners"
    role="img"
    :style="{ color: props.color }">
    <title>{{ props.title || props.name }}</title>
    <desc v-if="props.desc">{{ props.desc }}</desc>
    <template v-for="(path, index) in $options.methods.getIcon(props)">
      <path :d="path" :key="index"/>
    </template>
  </svg>
</template>

<style lang="sass">
.icon
  fill: currentColor
  &.is-mobility
    fill: #039be5
  &.is-red
    fill: rgba(235,0,0)
  &.is-strokeMobility
    fill: none
    stroke: #819ca9
    stroke-width: 4%
  &.is-strokeGrey
    fill: none
    stroke: #00796b
    stroke-width: 4%
  &.is-strokeWhite
    fill: none
    stroke: #fff
    stroke-width:4%
  &.is-white
    fill: #fff
  &.is-black
    fill: #000
  &.is-clearOpacity
    fill: rgba(255,255,255,.1)
  &.is-oecko
    fill: #1cb7f9
  &.is-contact
    fill: #1976d2
  &.is-valid
    fill: #43a047
  &.is-micro
    height: .55em
    width: .55em
  &.is-tiny
    height: 1em
    width: 1em
  &.is-small
    height: 1.5em
    width: 1.5em
  &.is-inter
    height: 2.2em
    width: 2.2em
  &.is-normal
    height: 3em
    width: 3em
  &.is-medium
    height: 4em
    width: 4em
  &.is-large
    height: 5.5em
    width: 5.5em
  &.is-dock
    height: 4.2rem
    width: 4.2rem
</style>

<script>
import icons from './icons.json';

export default {
  name: 'AppIcon',
  props: {
    name: String,
    size: String,
    color: String,
    title: String,
    desc: String,
  },
  methods: {
    getIcon(props) {
      return icons[props.name].pathArray;
    },
    getViewbox(props) {
      return icons[props.name].viewbox;
    },
    getStyleClasses(props) {
      return [props.size, props.color].map(val => val && `is-${val}`);
    },
  },
};
</script>
